import React from 'react';
import { useNavigate } from 'react-router-dom';

const ProductCardHome = ({ product }) => {
    const navigate = useNavigate();
    const parsedImages = Array.isArray(product.images) ? product.images : JSON.parse(product.images || '[]');
    return (
        <div className="relative cursor-pointer duration-300 shadow-lg hover:shadow-[#cccccc25] !h-[400px] overflow-hidden" onClick={() => navigate(`/product/${product.id}`)}>
            <img src={parsedImages[0] || '/placeholder.jpg'} alt={product.title} className="h-full object-cover" />
            <div className='absolute bottom-0 w-full h-1/2 left-0 p-4 text-white before:absolute before:inset-0 before:backdrop-blur-[6px] before:bg-transparent before:[-webkit-mask-image:linear-gradient(to_top,black,transparent)] before:[mask-image:linear-gradient(to_top,black,transparent)]'>
                <div className="relative z-10 pt-5">
                    <h3 className="font-bold mt-2">{product.title}</h3>
                    <h3 className="font-bold mt-2">{product.category}</h3>
                    <p className="opacity-50">{product.brand_name} - ${product.price}</p>
                    <p className="text-sm opacity-50">Updated: {new Date(product.update_date).toLocaleDateString()}</p>
                </div>
            </div>
        </div>
    )
};

export { ProductCardHome };